/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from 'react';
import Header from './header';
import Footer from './footer';
import Cookies from './cookies';
import './base.scss';
import './theme.scss';
import './site-addon-styles.scss';
import '@fortawesome/fontawesome-pro/css/all.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var gatsbyConfig = require('../../theme-config.js');

var gatsbyConfigSiteMetaData = gatsbyConfig.siteMetadata;
var gatsbyConfigPlugins = gatsbyConfig.plugins;
var gatsbyConfigPluginsAP = gatsbyConfigPlugins.find(function (o) {
  return o.resolve === 'gatsby-plugin-accropress';
});
var gatsbyConfigPluginsAPOptions = gatsbyConfigPluginsAP && gatsbyConfigPluginsAP.resolve === 'gatsby-plugin-accropress' && gatsbyConfigPluginsAP.options ? gatsbyConfigPluginsAP.options : {};

var Layout = function Layout(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "main-app-wrap",
    children: [/*#__PURE__*/_jsx(Header, Object.assign({}, props, {
      pluginOptions: props.pluginOptions || {},
      gatsbyConfigSiteMetaData: gatsbyConfigSiteMetaData,
      gatsbyConfigPluginsAPOptions: gatsbyConfigPluginsAPOptions
    })), /*#__PURE__*/_jsx("link", {
      href: "https://fonts.googleapis.com/css?family=Poppins&display=swap",
      rel: "stylesheet"
    }), /*#__PURE__*/_jsx("div", {
      className: "app-layout",
      children: /*#__PURE__*/_jsx("main", {
        children: props.children
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "footer-layout",
      children: [/*#__PURE__*/_jsx(Footer, {
        pluginOptions: props.pluginOptions || {},
        gatsbyConfigSiteMetaData: gatsbyConfigSiteMetaData,
        gatsbyConfigPluginsAPOptions: gatsbyConfigPluginsAPOptions
      }), /*#__PURE__*/_jsx(Cookies, {
        pluginOptions: props.pluginOptions || {},
        gatsbyConfigSiteMetaData: gatsbyConfigSiteMetaData,
        gatsbyConfigPluginsAPOptions: gatsbyConfigPluginsAPOptions
      })]
    })]
  });
};

export default Layout;